import type { AttachmentData } from "@/lib/chat-types";

export function AttachmentCard({ attachment }: { attachment: AttachmentData }) {
  const statusLabel = attachment.status === "reviewed" ? "Reviewed" : attachment.status === "scanning" ? "Scanning" : "Uploaded";

  return (
    <div className="flex items-center gap-3 px-3.5 py-2.5 border border-[var(--color-border)] rounded-[10px] bg-[var(--color-surface)] mb-2">
      <div className="w-9 h-9 rounded-lg bg-[var(--color-accent)]/10 flex items-center justify-center shrink-0">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" /><path d="M14 2v6h6" /><path d="M16 13H8" /><path d="M16 17H8" /><path d="M10 9H8" />
        </svg>
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[13px] font-medium text-[var(--color-fg)] truncate">{attachment.filename}</div>
        <div className="text-[11px] text-[var(--color-fg-tertiary)] mt-0.5" style={{ fontFamily: "var(--font-mono)" }}>
          {attachment.filesize} &middot; {attachment.filetype.toUpperCase()}
        </div>
      </div>
      {attachment.status && (
        <span
          className="px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wide bg-green-500/10 text-green-500"
          style={{ fontFamily: "var(--font-mono)" }}
        >
          {statusLabel}
        </span>
      )}
    </div>
  );
}
